import { PriceFormat } from '../components/Price/types'
export const getDecimalPrice = (fractionalPrice: string): number => {
  const fractional = fractionalPrice.split('/')
  const numerator = Number(fractional[0])
  const denominator = Number(fractional[1])
  return numerator / denominator
}

export const getMeasurablePrice = (price: string | PriceFormat): number => {
  if (typeof (price) === "string") {
    if (price.includes("/")) return getDecimalPrice(price)
    return Number(price)
  }
  return (price && price.decimal) || 0
}